/* eslint-disable func-names, prefer-template */
/* globals DocNav */

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
window.DocNav = {
  getDocLocalAnchors() {
    // target local links [href="#location"],
    // target link with relative urls [href="window.location.pathname+#location"]
    const $localAnchors = $(
      '[data-js-docs-article-content] a[href^="#"], [data-js-docs-article-content] a[href^="' +
        window.location.pathname +
        '#"] ',
    );
    return $localAnchors;
  },

  // marker storage
  markers: null,

  // dom traversal getter
  getMarkers() {
    return $('[data-js-docs-article-content] :header');
  },

  appendAnchor(target) {
    const anchorIcon = '<svg class="ai ai-link" role="presentation"><use xlink:href="#ai-link"></use></svg>';
    const id = target.attr('id');
    const dataHref = window.location.origin + window.location.pathname + '#' + id;

    target.append(
      $('<a />')
        .addClass('header-link u-p-r-small ai-16dp ai-va-middle')
        .attr('data-href', dataHref)
        .attr('data-id', id)
        .html(anchorIcon),
    );
  },

  removeAnchor(target) {
    const id = target.attr('id');
    target.find(`[data-id='${id}']`).remove();
  },

  renderPopup() {
    let classes;
    const $link = $(this);
    const offsetTop = $link.offset().top;
    const positionLeft = $link.position().left;
    const scrollPosition = $(window).scrollTop();
    const windowWidth = $(window).width();
    const distanceFromTop = offsetTop - scrollPosition;

    if (windowWidth > 991) {
      if (distanceFromTop > 180) {
        classes = 'c-popup c-popup--documentation c-popup--top';
      } else {
        classes = 'c-popup c-popup--documentation c-popup--bottom';
      }
    } else {
      classes = 'c-popup c-popup--documentation c-popup--right';
    }

    $link
      .parent()
      .append($('<div />').addClass(classes).html('Copy to clipboard').css('left', positionLeft).hide().fadeIn(200));
  },

  removePopup() {
    const popupElm = $(this).parent().find('.c-popup');
    popupElm.not('.c-popup--success').remove();
  },

  handleAnchorClick() {
    let tempInput;
    const href = $(this).attr('data-href');
    const popupElm = $(this).parent().find('.c-popup');
    const id = $(this).attr('data-id');

    // fire event so other components can react to it
    // @see views/tutorials/show.js
    document.dispatchEvent(new CustomEvent('docs:anchor-copy-to-clipboard', { detail: { value: href } }));

    // still updates the location hash but prevents scrollTo
    const scrollLocation = $(window).scrollTop();
    window.location = `#${id}`;
    $(window).scrollTop(scrollLocation);

    // Creates a temporary input to handle the copy process
    // This field is later removed from the document
    $(this)
      .parent()
      .append((tempInput = $('<input />').attr('type', 'text').attr('value', href).addClass()));

    tempInput.focus();
    tempInput.select();

    if (document.execCommand('copy')) {
      tempInput.remove();
      popupElm.html('<span class="fa fa-check"></span> Copied to clipboard').addClass('c-popup--success');

      popupElm.delay(1750).fadeOut(350, function () {
        $(this).remove();
      });
    }
  },

  toggleEvents(target, $OnOrOffMethod) {
    // Appends the popup on mouseenter and removes it on mouseleave
    target[$OnOrOffMethod]('mouseenter', '.header-link', DocNav.renderPopup);
    target[$OnOrOffMethod]('mouseleave', '.header-link', DocNav.removePopup);

    // Handles the click on anchor link:
    // Copy the text to clipboard and changes the popup
    // information to a success message to then hide and remove it
    target[$OnOrOffMethod]('click', '.header-link', DocNav.handleAnchorClick);
  },

  // Icon that appears next to headers with anchor names
  // that allows a user to click on and link to
  setupAnchorLinksForHeaders() {
    this.markers = this.getMarkers();

    this.markers.each(function () {
      const $this = $(this);
      const id = $this.attr('id');

      if (id) {
        DocNav.appendAnchor($this);
        // Appends the popup on mouseenter and removes it on mouseleave
        DocNav.toggleEvents($this, 'on');
      }
    });
  },

  // remove elements and events of generated header anchor links
  destroyAnchorLinksForHeaders() {
    this.markers.each(function () {
      const $this = $(this);
      const id = $this.attr('id');

      if (id) {
        // avoid memory leaks by removing previously
        // setted up events
        DocNav.removeAnchor($this);
        DocNav.toggleEvents($this, 'off');
      }
    });
  },

  // recreate the whole thing for those cases where dom is not ready
  // on load of this script (example: tutorials/show)
  rebootAnchorLinksForHeaders() {
    this.destroyAnchorLinksForHeaders();
    this.setupAnchorLinksForHeaders();
  },
};
